import React from 'react';
import { FileText } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

interface ViewAnswersButtonProps {
  onClick: () => void;
  className?: string;
}

const ViewAnswersButton: React.FC<ViewAnswersButtonProps> = ({ onClick, className = '' }) => {
  const { t } = useLanguage();
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center justify-center gap-1.5 text-sm font-medium px-3 py-1.5 bg-blue-50 hover:bg-blue-100 text-blue-600 rounded-lg transition-colors ${className}`}
      title={t('candidates.referenceModals.referencesTable.viewAnswers')}
    >
      <FileText className="w-4 h-4" />
      <span>{t('candidates.referenceModals.referencesTable.viewAnswers')}</span>
    </button>
  );
};

export default ViewAnswersButton;